import { render, staticRenderFns } from "./ByJsonBlock.vue?vue&type=template&id=1faddae2&scoped=true&functional=true&"
import script from "./ByJsonBlock.vue?vue&type=script&lang=js&"
export * from "./ByJsonBlock.vue?vue&type=script&lang=js&"
import style0 from "./ByJsonBlock.vue?vue&type=style&index=0&id=1faddae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "1faddae2",
  null
  
)

export default component.exports